import { render } from "./formTooltip.vue?vue&type=template&id=f67ab1b8&scoped=true"
import script from "./formTooltip.vue?vue&type=script&lang=js"
export * from "./formTooltip.vue?vue&type=script&lang=js"

import "./formTooltip.vue?vue&type=style&index=0&id=f67ab1b8&scoped=true&vars=%7BX%2C%20Y%2C%20flip%7D&lang=css"
script.render = render
script.__scopeId = "data-v-f67ab1b8"

export default script